export interface SettingsAttorneysUsersRouter {
  goToList(query?: string): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SettingsAttorneysUsersRouter = Symbol(
  'SettingsAttorneysUsersRouter',
);
